// import { useState } from "react";

function BackGroundColor({ isNight, setIsNight }) {
  // const [isNight, setIsNight] = useState(false);
  return (
    <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0">
      {/* Sky */}
      <div
        className={`absolute top-0 left-0 w-full h-full transition-colors duration-1000 ${
          isNight ? "bg-indigo-950" : "bg-blue-200"
        }`}
      >
        {/* Stars (only visible at night) - More and bigger */}
        {isNight && (
          <>
            {/* Large stars */}
            <div className="absolute top-10 left-20 w-2 h-2 bg-yellow-200 rounded-full animate-pulse"></div>
            <div className="absolute top-20 left-40 w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-16 left-60 w-2 h-2 bg-yellow-100 rounded-full animate-pulse"></div>
            <div className="absolute top-32 left-80 w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-12 left-96 w-2 h-2 bg-yellow-200 rounded-full animate-pulse"></div>
            <div className="absolute top-24 right-20 w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-40 right-40 w-2 h-2 bg-yellow-100 rounded-full animate-pulse"></div>
            <div className="absolute top-8 right-60 w-2 h-2 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-28 right-80 w-2 h-2 bg-yellow-200 rounded-full animate-pulse"></div>
            <div className="absolute top-36 right-96 w-2 h-2 bg-white rounded-full animate-pulse"></div>

            {/* Medium stars */}
            <div className="absolute top-14 left-32 w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-26 left-52 w-1.5 h-1.5 bg-yellow-100 rounded-full animate-pulse"></div>
            <div className="absolute top-18 left-72 w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-30 left-100 w-1.5 h-1.5 bg-yellow-200 rounded-full animate-pulse"></div>
            <div className="absolute top-22 left-120 w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-34 right-32 w-1.5 h-1.5 bg-yellow-100 rounded-full animate-pulse"></div>
            <div className="absolute top-12 right-52 w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-38 right-72 w-1.5 h-1.5 bg-yellow-200 rounded-full animate-pulse"></div>
            <div className="absolute top-16 right-100 w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-44 right-120 w-1.5 h-1.5 bg-yellow-100 rounded-full animate-pulse"></div>

            {/* Small stars - lots of them */}
            <div className="absolute top-8 left-16 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-24 left-28 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-12 left-44 w-1 h-1 bg-yellow-100 rounded-full"></div>
            <div className="absolute top-28 left-64 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-16 left-88 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-36 left-108 w-1 h-1 bg-yellow-100 rounded-full"></div>
            <div className="absolute top-20 left-128 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-40 left-144 w-1 h-1 bg-white rounded-full"></div>

            <div className="absolute top-10 right-16 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-26 right-28 w-1 h-1 bg-yellow-100 rounded-full"></div>
            <div className="absolute top-14 right-44 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-30 right-64 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-18 right-88 w-1 h-1 bg-yellow-100 rounded-full"></div>
            <div className="absolute top-42 right-108 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-22 right-128 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-46 right-144 w-1 h-1 bg-yellow-100 rounded-full"></div>

            {/* Center area stars */}
            <div className="absolute top-6 left-1/2 w-2 h-2 bg-yellow-200 rounded-full animate-pulse"></div>
            <div className="absolute top-15 left-1/3 w-1.5 h-1.5 bg-white rounded-full animate-pulse"></div>
            <div className="absolute top-25 left-2/3 w-1.5 h-1.5 bg-yellow-100 rounded-full animate-pulse"></div>
            <div className="absolute top-35 left-1/4 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-45 left-3/4 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-11 left-1/2 w-1 h-1 bg-yellow-100 rounded-full"></div>
            <div className="absolute top-21 left-5/12 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-31 left-7/12 w-1 h-1 bg-white rounded-full"></div>
            <div className="absolute top-41 left-2/5 w-1 h-1 bg-yellow-100 rounded-full"></div>
            <div className="absolute top-48 left-3/5 w-1 h-1 bg-white rounded-full"></div>
          </>
        )}

        {/* Clouds (fade out at night) */}
        <div
          className={`transition-opacity duration-1000 ${
            isNight ? "opacity-20" : "opacity-100"
          }`}
        >
          <div className="absolute top-10 left-10 w-24 h-16 bg-white rounded-full"></div>
          <div className="absolute top-8 left-20 w-32 h-16 bg-white rounded-full"></div>
          <div className="absolute top-10 left-16 w-28 h-20 bg-white rounded-full"></div>

          <div className="absolute top-20 right-20 w-32 h-16 bg-white rounded-full"></div>
          <div className="absolute top-16 right-32 w-28 h-20 bg-white rounded-full"></div>
          <div className="absolute top-24 right-16 w-20 h-16 bg-white rounded-full"></div>
        </div>

        {/* Sun/Moon - clickable */}
        <button
          onClick={() => {
            setIsNight(!isNight);
          }}
          // Buraya z-50 ekledik ki en öne çıksın
          className={`absolute top-6 right-6 w-20 h-20 rounded-full transition-all duration-1000 cursor-pointer hover:scale-110 z-50 ${
            isNight ? "bg-gray-100" : "bg-yellow-300"
          }`}
        >
          {isNight && (
            <>
              <div className="absolute top-3 left-4 w-3 h-3 bg-gray-300 rounded-full"></div>
              <div className="absolute top-8 left-10 w-4 h-4 bg-gray-300 rounded-full"></div>
              <div className="absolute top-12 left-6 w-2 h-2 bg-gray-300 rounded-full"></div>
            </>
          )}
        </button>

        {/* Ground area */}
        <div className="absolute bottom-0 left-0 w-full h-40">
          <div
            className={`absolute bottom-0 left-0 w-full h-20 transition-colors duration-1000 ${
              isNight ? "bg-green-800" : "bg-green-400"
            }`}
          ></div>
          <div
            className={`absolute bottom-20 left-0 w-full h-20 transition-colors duration-1000 ${
              isNight ? "bg-green-700" : "bg-green-300"
            }`}
          ></div>
        </div>

        {/* Tree on the left */}
        <div className="absolute bottom-20 left-24 w-32 h-48">
          <div
            className={`absolute bottom-0 left-12 w-8 h-20 rounded-b-lg transition-colors duration-1000 ${
              isNight ? "bg-yellow-900" : "bg-yellow-800"
            }`}
          ></div>
          <div
            className={`absolute bottom-16 left-0 w-32 h-32 rounded-full transition-colors duration-1000 ${
              isNight ? "bg-green-900" : "bg-green-600"
            }`}
          ></div>
          <div
            className={`absolute bottom-20 left-4 w-24 h-28 rounded-full transition-colors duration-1000 ${
              isNight ? "bg-green-950" : "bg-green-700"
            }`}
          ></div>
          <div
            className={`absolute bottom-16 left-8 w-16 h-24 rounded-full transition-colors duration-1000 ${
              isNight ? "bg-green-950" : "bg-green-800"
            }`}
          ></div>
        </div>

        {/* Tree on the right */}
        <div className="absolute bottom-20 right-24 w-32 h-48">
          <div
            className={`absolute bottom-0 left-12 w-8 h-20 rounded-b-lg transition-colors duration-1000 ${
              isNight ? "bg-yellow-900" : "bg-yellow-800"
            }`}
          ></div>
          <div
            className={`absolute bottom-16 left-0 w-32 h-32 rounded-full transition-colors duration-1000 ${
              isNight ? "bg-green-900" : "bg-green-600"
            }`}
          ></div>
          <div
            className={`absolute bottom-20 left-4 w-24 h-28 rounded-full transition-colors duration-1000 ${
              isNight ? "bg-green-950" : "bg-green-700"
            }`}
          ></div>
          <div
            className={`absolute bottom-16 left-8 w-16 h-24 rounded-full transition-colors duration-1000 ${
              isNight ? "bg-green-950" : "bg-green-800"
            }`}
          ></div>
        </div>

        {/* Characters */}
        <div className="absolute bottom-20 left-80 w-16 h-24 bg-orange-500 rounded-t-full"></div>
        <div className="absolute bottom-20 right-80 w-16 h-24 bg-purple-500 rounded-t-full"></div>
      </div>
    </div>
  );
}

export default BackGroundColor;
